<template>
  <div id="app" :class="{'android': isAndroid}">
    <router-view></router-view>
  </div>
</template>
<script>
import NativeApi from 'native-api'
import { inputScrollIntoView } from '@/util/dom-util'
import { isAndroid } from '@/util/common-util'
export default {
    name: 'App',
    data() {
        return {
            isAndroid,
        }
    },
    mounted() {
        // 移动端输入框获取焦点后自动滚动到位置
        isAndroid && inputScrollIntoView({
            useRem: true,
        })
        NativeApi.invoke('hiddenCloseBtn',{"hiddenClose":"1"})
    }
}
</script>
<style lang="scss">
html, body{
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}
#app {
  color: #2c3e50;
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  // padding: 12px 12px 0;
}
.car-table {
    width: 100%;
}
.me-radio__label,
.me-checkbox__label{
    word-wrap: break-word !important;
	word-break:break-all !important;
	white-space: normal !important;
}
.me-dialog .me-dialog__message {
    padding-left: .48rem;
    padding-right: .48rem;
}
@media screen and (min-width: 920px) {
   .head-prop .me-nav-bar{
        max-width: 100%;
    }
}
</style>

